import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const JobPriorityCBadge = (props: StatusBadgeProps) => {
    const {
        width = "24",
        height = "24",
        viewBox = "0 0 20 20",
        ...rest
    } = props;

    return (
        <svg
            width={width}
            height={height}
            viewBox={viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="20"
                height="20"
                rx="3"
                fill="#A6D3F4"
                fillOpacity="0.6"
            />
            <path
                d="M10.7484 14.1495C12.4274 14.1495 13.6809 13.333 14.2674 11.815L13.1059 11.378C12.7264 12.436 11.9099 12.9765 10.7484 12.9765C9.12692 12.9765 8.17242 11.8955 8.17242 9.975C8.17242 8.066 9.12692 6.9965 10.7714 6.9965C11.9214 6.9965 12.7264 7.514 13.1059 8.5605L14.2444 8.1235C13.6579 6.617 12.4389 5.8235 10.7714 5.8235C8.42542 5.8235 6.94192 7.4105 6.94192 9.9865C6.94192 12.551 8.41392 14.1495 10.7484 14.1495Z"
                fill="#21006E"
            />
        </svg>
    );
};
